export default {
  URL_START_WITH_HTTP: 'URL, start with http(s)',
  SELECT_VERTICAL: 'Select Vertical',
  SELECT_INDUSTRY: 'Select Industry',
};
